module.exports = __webpack_public_path__ + "static/media/ic_arrow_l.b2f68bd9.svg";